var map = {
	"./circle.png": 82,
	"./cube.png": 83,
	"./dodecahedron.png": 84,
	"./icosahedron.png": 85,
	"./nowhere.png": 86,
	"./octahedron.png": 87,
	"./tetrahedron.png": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;